import Toc from 'igs-theme-core/src/assets/scripts/modules/toc'
import Favorites from 'igs-theme-core/src/assets/scripts/modules/favorites'
import ContentWrapper from 'igs-theme-core/src/assets/scripts/modules/content-wrapper'
import Lightbox from 'igs-theme-core/src/assets/scripts/modules/lightbox'
import LoadPartials from 'igs-theme-core/src/assets/scripts/modules/load-partials'
import WatuPro from './modules/watupro'
import Sticky from 'sticky-js'

document.addEventListener('DOMContentLoaded', () => {
    const sticky = document.querySelectorAll('.js-sticky')
    if (sticky.length) {
        sticky.forEach((el) => {
            el.parentElement.dataset.stickyContainer = true
        })
        new Sticky('.js-sticky', {
            stickyClass: 'sticky--active',
        })
    }

    const tocs = document.querySelectorAll('.js-article-toc')
    tocs.forEach((toc) => {
        new Toc(toc, { waypoint: true })
    })

    const locationSelects = document.querySelectorAll('.js-location-change-select')
    locationSelects.forEach((select) => {
        new LocationChangeSelect(select)
    })

    const favorites = document.querySelectorAll('.js-favorites')
    favorites.forEach((favorite) => {
        new Favorites(favorite)
    })
    const iframes = document.querySelectorAll('.post-content > iframe, .post-content > p > iframe')
    iframes.forEach((iframe) => {
        new ContentWrapper(iframe, 'iframe-wrap')
    })
    
    const lessons = document.querySelectorAll('.js-load-lessons')
    lessons.forEach((lesson) => {
        new LoadPartials(lesson, false, 'lessons_list', 'click')
    })
    
    new Lightbox()
    new WatuPro()
})